import axios from "axios";
import { ApiProvider } from "@src/store/ApiProvider";

export const extractPasswordManagerError = (error: unknown, fallback: string): string => {
	if (axios.isAxiosError(error)) {
		const data = error.response?.data as { message?: string; Message?: string } | string | undefined;
		if (typeof data === "string" && data.trim()) return data;
		if (data && typeof data === "object") {
			const msg = data.message || data.Message;
			if (msg) return msg;
		}
		if (error.message) return error.message;
	}
	if (error instanceof Error && error.message) return error.message;
	return fallback;
};

export const getPasswordManagerAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
		"Content-Type": "application/json",
	};
};

export const passwordManagerUrl = (path: string) => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "";
	return `${baseUrl.replace(/\/$/, "")}${path}`;
};
